<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-2">
            <v-form @submit.prevent="reqPhoneNumbers">
              <v-toolbar color="primary">
                <v-toolbar-title>Add a new number</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
<!--              error bar-->
              <v-layout row v-if="error">
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-layout>
              <v-card-text>
                <v-text-field
                    prepend-icon="mdi-phone-check"
                    v-model="phoneNumberSearch"
                    :counter="10"
                    :rules="numberRules"
                    label="Search number"
                    outlined
                    required
                    type="number"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined type="submit" :disabled="loading" :loading="loading">
                  Find phonenumbers
                <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                </span>
              </v-btn>
            </v-card-actions>
            </v-form>

            <v-simple-table v-if="availablePhoneNumbers">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Phone Number
                  </th>
                  <th class="text-left">
                    Locality
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="item in availablePhoneNumbers"
                    :key="item.phoneNumber"
                >
                  <td>{{ item.friendlyName }}</td>
                  <td>{{ item.locality }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>

          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
//import { collection, doc, getDocs, setDoc,onSnapshot } from "firebase/firestore";
import { getFunctions, httpsCallable  } from 'firebase/functions';
export default {
  name: "scafold",
  data: () => ({
    email: '',
    password: '',
    signUp: false,
    name: '',
    numberRules: [
      v => !!v || 'First part of number is required',
      v => (v && v.length <= 10) || 'First parts of number must be 3 digits max',
    ],
    phoneNumberSearch: '',
    availablePhoneNumbers: null
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    reqPhoneNumbers () {
      this.$store.dispatch('setLoading', true)
      this.$store.dispatch('clearError')
      const functions = getFunctions()
      const twilioNumberSearch = httpsCallable(functions, 'twilioNumberSearch')
      twilioNumberSearch({numbers: this.phoneNumberSearch})
      .then(res => {
        console.log(res.data)
        // console.log(res.data.availableNumbers)
        if (res.data.availableNumbers.length !== 0) {
          this.availablePhoneNumbers = res.data.availableNumbers
          this.phoneNumberSearch =''
        } else {
          this.availablePhoneNumbers = null
          this.$store.dispatch('setError', {message: 'Shoot! No available phone numbers found..lets try again.'})
        }
        this.$store.dispatch('setLoading', false)
      })
      .catch(err => {
        console.log(err)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('setError', err)
      })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

